export default [
    {
        target: '.single-project__header',
        file: async () => (await import(/* webpackChunkName: "project-slider/slider" */'./project-slider/ProjectSlider')).default,
    }
]